<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <dl class="space-y-2">
        @for (description of descriptionListConfig; track description.term) {
            <div>
                <dt class="font-bold">{{ description.term }}</dt>
                <dd class="ms-4 text-gray-600">
                    {{ description.details }}
                </dd>
            </div>
        }
    </dl>
</apcam-shared-dialog-shell>
